import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/common.json';
import ptBR from './locales/pt-BR/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt-BR'],

    resources: {
      en: { common: en },
      'pt-BR': { common: ptBR },
    },

    defaultNS: 'common',

    detection: {
      // Detection order: user's saved choice → browser/device language → HTML lang tag
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'virtus_language',
    },

    interpolation: {
      escapeValue: false, // React already handles XSS escaping
    },
  });

export default i18n;
